import React, { useEffect } from "react";
import Style from "../styles/navbar.module.scss";
import { useSelector, useDispatch } from "react-redux";
import { dropdown } from "../redux/index";
import { useNavigate } from "react-router-dom";
import  { adminRoutes } from "../routers/AdminRouters";
import Logo_Icon from "../assets/auth/logo.png";
import Logout_Icon from "../assets/dashboard/Menu/logout.png";
import { IoIosArrowDown } from "react-icons/io";
import { logoutGym } from "../services";
import { getGymProfile } from "../services/gymService";

const Navbar = () => {
  const issidebar = useSelector((state) => state.navbar.sidemenu);
  const { gym } = useSelector((state) => state.gym);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = async () => {
    dispatch(logoutGym());
    navigate(adminRoutes.login);
  };

  useEffect(() => {
    getGymProfile();
  }, []);

  return (
    <div className={Style.navbarmaincontainer}>
      <nav className={Style.navbar}>
        <div className={Style.navbar_left}>
          <div className={Style.logo}>
            <img src={Logo_Icon} alt="logo"/>
          </div>
        </div>
        <div className={Style.navbar_right}>
          <div className={Style.user_info}>
            <div className={Style.user_logo}></div>

            <div className={Style.user_data}>
              <div className={Style.user_name}>
                <h1>{gym?.name}</h1>
                {/* <p>GYM</p> */}
              </div>

              <div
                onClick={() => dispatch(dropdown())}
                className={Style.userarrowdown}
              >
                <IoIosArrowDown />
              </div>

              {issidebar ? (
                <div className={Style.dropdown_password}>
                  <div className={Style.dropdown_password_img}>
                    <img src={Logout_Icon} alt="logout"/>
                  </div>
                  <div
                    className={Style.dropdown_password_text}
                    onClick={handleLogout}
                  >
                    <h2>Log out</h2>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
